import { DeveloperPage } from './DeveloperPage';
import { withLayout } from '../../layout/Layout';

export default withLayout(DeveloperPage);